import React, { useContext } from "react";
import OrderContext from "../../../../context/OrderContext";

const ActiveFilters = () => {
  let {
    setSearchParams,
    searchParams,
    clearFilters,
    orderby,
    setOrderby,
    shippingstatus,
    setShippingStatus,
    orderstatus,
    setOrderStatus,
    vendor,
    setVendor,
  } = useContext(OrderContext);

  function handleClearFilter() {
    clearFilters();
  }

  function handleClearOrderby() {
    setOrderby("");
    searchParams.delete("order_by");
    setSearchParams(searchParams.toString());
  }

  function handleClearShippingstatus() {
    setShippingStatus("");
    searchParams.delete("shipping_status");
    setSearchParams(searchParams.toString());
  }

  function handleClearOrderstatus() {
    setOrderStatus("");
    searchParams.delete("status");
    setSearchParams(searchParams.toString());
  }

  function handleClearVendor() {
    setVendor("");
    searchParams.delete("vendor");
    setSearchParams(searchParams.toString());
  }

  return (
    <>
      <div className="active-filters">
        {orderby ? (
          <span>
            {orderby.replace(/_/g, " ")}
            <button onClick={handleClearOrderby}>
              <i className="feather icon-x"></i>
            </button>
          </span>
        ) : (
          " "
        )}
        {shippingstatus ? (
          <span>
            {shippingstatus.replace(/_/g, " ")}
            <button onClick={handleClearShippingstatus}>
              <i className="feather icon-x"></i>
            </button>
          </span>
        ) : (
          " "
        )}
        {orderstatus ? (
          <span>
            {orderstatus.replace(/_/g, " ")}
            <button onClick={handleClearOrderstatus}>
              <i className="feather icon-x"></i>
            </button>
          </span>
        ) : (
          " "
        )}
        {vendor ? (
          <span>
            {vendor.replace(/-/g, " ")}
            <button onClick={handleClearVendor}>
              <i className="feather icon-x"></i>
            </button>
          </span>
        ) : (
          " "
        )}

        {orderby || shippingstatus || orderstatus || vendor ? (
          <button onClick={handleClearFilter} className="clear-filter">
            Clear<i className="feather icon-x"></i>
          </button>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default ActiveFilters;
